import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { TbSortAscending, TbSortDescending } from "react-icons/tb";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FilterProps } from "./types";
export type SortDirection = "asc" | "desc";
export interface SortOption {
  label: string;
  value: string;
}
interface SortFilterProps extends FilterProps {
  options: SortOption[];
  value?: {
    sortBy: string;
    sortDirection: SortDirection;
  };
}
const SortFilter: React.FC<SortFilterProps> = t0 => {
  const $ = _c(26);
  const {
    onChange,
    options,
    value
  } = t0;
  const [field, setField] = useState(value?.sortBy ?? options[0]?.value ?? "");
  const [direction, setDirection] = useState(value?.sortDirection ?? "desc");
  if (!options || options.length === 0) {
    console.warn("SortFilter: No options provided");
    return null;
  }
  let t1;
  if ($[0] !== direction || $[1] !== onChange) {
    t1 = newField => {
      setField(newField);
      const newValue = {
        sortBy: newField,
        sortDirection: direction
      };
      onChange(newValue);
    };
    $[0] = direction;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleFieldChange = t1;
  let t2;
  if ($[3] !== direction || $[4] !== field || $[5] !== onChange) {
    t2 = () => {
      const newDirection = direction === "asc" ? "desc" : "asc";
      setDirection(newDirection);
      const newValue_0 = {
        sortBy: field,
        sortDirection: newDirection
      };
      onChange(newValue_0);
    };
    $[3] = direction;
    $[4] = field;
    $[5] = onChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const toggleDirection = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectTrigger className="mt-2"><SelectValue /></SelectTrigger>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== options) {
    t4 = options.map(_temp);
    $[8] = options;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <SelectContent>{t4}</SelectContent>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== field || $[13] !== handleFieldChange || $[14] !== t5) {
    t6 = <Select value={field} onValueChange={handleFieldChange}>{t3}{t5}</Select>;
    $[12] = field;
    $[13] = handleFieldChange;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  let t8;
  if ($[16] !== direction) {
    t7 = direction === "asc" ? <TbSortAscending className="h-4 w-4" /> : <TbSortDescending className="h-4 w-4" />;
    t8 = direction === "asc" ? <span>{"Ascending"}</span> : <span>{"Descending"}</span>;
    $[16] = direction;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== toggleDirection) {
    t9 = <div className="mt-2 flex items-center justify-between"><button type="button" onClick={toggleDirection} className="flex items-center gap-2 rounded-lg border  px-4 py-2 text-body-strong text-foreground-secondary shadow-sm hover:bg-row-hover">{t7}{t8}</button></div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = toggleDirection;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t6 || $[24] !== t9) {
    t10 = <div className="mx-auto max-w-xs">{t6}{t9}</div>;
    $[23] = t6;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default SortFilter;
function _temp(option) {
  return <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>;
}